import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {EnvironmentService} from '@iw-shop/core//services/environment.service';
import {take} from 'rxjs/operators';
import {getSelectedCustomer} from '@store/selectors/user.selector';
import {Observable} from 'rxjs';
import {
    ApiPaymentsPaypalSetPaymentRequest, ApiPaymentsPaypalSetPaymentResponse,
    ApiPaymentsPaypalGetPaymentUrlRequest, ApiPaymentsPaypalGetPaymentUrlResponse,
    ApiPaymentsPaypalGetPaymentRequest,
    ApiPaymentsPaypalGetPaymentResponse, ApiPaymentsPaypalGetPaymentUrlByOrderRequest
} from '@api/payments';

@Injectable({
  providedIn: 'root'
})
export class PaypalService {

  constructor(private http: HttpClient, private store: Store<AppState>, private environmentService: EnvironmentService) {
  }

    getPaymentUrl(paymentMethod: 'paypal' | 'paypalExpress', step: string = '1'): Promise<string> {
        let shoppingCartId: string = '', shoppingCartToken: string = '', priceMode: 'gross' | 'net' = 'gross',
            returnUrl = '', cancelUrl = '';
        this.store.select(state => state).pipe(take(1)).subscribe(r => {
            shoppingCartId = r.shoppingCart.id;
            shoppingCartToken = r.shoppingCart.token;
            returnUrl = r.config.shopUrl + 'checkout/' + step + '?paymentMethod=' + paymentMethod + '&shoppingCartId=' + shoppingCartId + '&shoppingCartToken=' + shoppingCartToken;
            cancelUrl = r.config.shopUrl + 'cart?paymentAborted=true&externalPaymentId=' + shoppingCartId + '&shoppingCartToken=' + shoppingCartToken;
        });
        this.store.select(getSelectedCustomer).pipe(take(1)).subscribe(c => {
            if (c?.priceMode) {
                priceMode = c.priceMode
            }
        });
        return new Promise((resolve, reject) => {
            const body: ApiPaymentsPaypalGetPaymentUrlRequest = {
                id: 'paypalGetPaymentUrl',
                command: 'payments/paypal/getPaymentUrl',
                params: {
                    data: {
                        shoppingCartId,
                        shoppingCartToken,
                        priceMode,
                        returnUrl,
                        cancelUrl
                    }
                }
            };
            this.http.post<ApiPaymentsPaypalGetPaymentUrlResponse>(this.environmentService.environment.urlApi, JSON.stringify(body))
                .subscribe(
                    {
                        next: (r) => {
                            if (r.result?.payments.data.urlToPaymentProvider) {
                                resolve(r.result?.payments.data.urlToPaymentProvider);
                            } else {
                                reject();
                            }
                        },
                        error: () => {
                            reject();
                        }
                    }
                );

        });
    }

  getPaymentUrlByOrder(orderId: string, token: string, paymentMethod: 'paypal' | 'paypalExpress', step: string = '1'): Promise<string> {
    let priceMode: 'gross' | 'net' = 'gross',
      returnUrl = '', cancelUrl = '';
    this.store.select(state => state).pipe(take(1)).subscribe(r => {
      returnUrl = r.config.shopUrl + 'checkout/' + step + '?paymentMethod=' + paymentMethod + '&orderId=' + orderId + '&orderToken=' + token;
      cancelUrl = r.config.shopUrl + 'cart?paymentAborted=true&orderId=' + orderId + '&orderToken=' + token;
    });
    this.store.select(getSelectedCustomer).pipe(take(1)).subscribe(c => {
      if (c?.priceMode) {
        priceMode = c.priceMode
      }
    });
    return new Promise((resolve, reject) => {
      const body: ApiPaymentsPaypalGetPaymentUrlByOrderRequest = {
        id: 'paypalGetPaymentUrlByOrder',
        command: 'payments/paypal/getPaymentUrlByOrder',
        params: {
          data: {
            orderId,
            priceMode,
            returnUrl,
            cancelUrl
          }
        }
      };
      this.http.post<ApiPaymentsPaypalGetPaymentUrlResponse>(this.environmentService.environment.urlApi, JSON.stringify(body))
        .subscribe(
          {
            next: (r) => {
              if (r.result?.payments.data.urlToPaymentProvider) {
                resolve(r.result?.payments.data.urlToPaymentProvider);
              } else {
                reject();
              }
            },
            error: () => {
              reject();
            }
          }
        );

    });
  }

  setPayment(orderId: string, shoppingCartId: string, externalPaymentId: string): Observable<ApiPaymentsPaypalSetPaymentResponse> {
    const body: ApiPaymentsPaypalSetPaymentRequest = {
      id: 'paypalSetPayment',
      command: 'payments/paypal/setPayment',
      params: {
        data: {
          externalPaymentId,
          shoppingCartId,
          orderId
        }
      }
    };
    return this.http.post<ApiPaymentsPaypalSetPaymentResponse>(this.environmentService.environment.urlApi, JSON.stringify(body))
  }

  getPayment(externalPaymentId: string, shoppingCartId: string): Observable<ApiPaymentsPaypalGetPaymentResponse> {
    const body: ApiPaymentsPaypalGetPaymentRequest = {
      id: 'paypalGetPayment',
      command: 'payments/paypal/getPayment',
      params: {
        data: {
          externalPaymentId,
          shoppingCartId
        }
      }
    };
    return this.http.post<ApiPaymentsPaypalGetPaymentResponse>(this.environmentService.environment.urlApi, JSON.stringify(body))
  }
}
